import { EntityMigration } from "../../entity/EntityMigration";

export class DtoMigrationsPostRes extends EntityMigration {}
